// import React from 'react';
import React, {  useEffect  } from 'react';
import { useNavigate } from "react-router-dom";

const Logout = () => {

    const navigate = useNavigate();

    
    const Logout = async () =>{
        try{    
            const res = await fetch('/logout', {
                method : "POST",
                headers : {
                    Accept : "application/json",
                    "Content-Type" : "application/json"
                },
                credentials : "include"
            });

            if(res.status === 401 || !res ){
                window.alert("Please Logout Later");
            }else{
                navigate('/');
                window.location.reload()
            }
        } catch (error){
            console.log(error)
    }
    }

    useEffect (() => {
            Logout();
        }, []);



    return (
        <div>
           
          </div>
    )
}

export default Logout;


